import { Component, EventEmitter, Output, AfterViewInit, OnInit, ElementRef, ViewChild } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AuthService } from '../../core/auth-service.component';
import { UserService } from '../../commonservices/user.service';
import { UserProfile } from 'src/app/model/user-profile';
import { CookieService } from 'ngx-cookie';
import { CustomCookieService } from '../../commonservices/custom-cookie.service';
import { EnvService } from '../../core/env.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ShareService } from '../../commonservices/shared.service';
import {UserSettings} from 'src/app/model/UserSettings';
import Utils from 'src/app/helpers/Util';
import {GroupResult, groupBy, orderBy} from '@progress/kendo-data-query';
import { NotificationService } from '@progress/kendo-angular-notification';
import { MultiRaterService } from '../../multirater/service/multirater-service';
import { dataHistory, GlobalService } from '@global/global.service'
import {saveAs as importedSaveAs} from "file-saver"; 
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { filter, startWith, switchMap, distinctUntilChanged, debounceTime, mergeMap, takeUntil } from 'rxjs/operators';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { combineLatest, of } from 'rxjs';
import { AppService } from '@global/app.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

const defaultFilterValue = {
  docType: null,
  dateType:null,
  date: [[]],
  invoiceStatus: null,
  startDate: null,
  endDate: null,

  carrierName: '',
  invoiceNumber: '',
  shipmentID: ''
}

@Component({
  host: {
    '(document:click)': 'onClick($event)'
  },
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, AfterViewInit  {

  @Output() toggleSidebar = new EventEmitter<void>();
  @Output() optionsEvent = new EventEmitter<any>();
  @Output() settings = new EventEmitter<any>();
  @Output() currencyEvent = new EventEmitter<any>();

  environment: string;

  toggle:boolean = false;
  navForm: UntypedFormGroup;

  docTypes: any  = [{TextField:"Invoice",ValueField:"Invoice"},{TextField:"Credit Note",ValueField:"CreditNote"}];
  dateTypes: Array<string> = ['Invoice Date','Due Date','Receive Date']
  invoiceStatus:any;

  @ViewChild('myDrop', { static: false, read: NgbDropdown }) myDrop: NgbDropdown;
  @ViewChild('myLogout', { static: false, read: NgbDropdown }) logout: NgbDropdown;
  @ViewChild('listDrop', { static: false }) listDrop: ElementRef;

  load: boolean = false;
  filterForm: UntypedFormGroup;

  public config: PerfectScrollbarConfigInterface = {};
  public showSearch = false;
  public _userProfile: UserProfile = null;
  public applicatePage: string;
  public userSettings: UserSettings;
  public showLayouts: boolean =  false;
  public showSideBar: boolean = false;
  public newInvoice: boolean = false;
  public showWebRes: boolean = false;
  public showGeneralSettings: boolean = false;
  public groupCurrency: GroupResult[];
  public currencyDropDownList: Array<any>;

  public currencyTemplate: { 
    Code?: string, 
    Id?:number
  };

  public selectedItemCurrency: { 
    Code: null, 
    Id: null
  };

  public webResEmitValue = {Type:"",Value:""};
  public dataHistory: Array<any> = dataHistory;
  public roleClients: any;
  public isEmailAlert:boolean = false;

  public monday:any =  {name :"Monday", id: 1,isCheck:false,value:'Mon'};
  public tuesday:any =  {name :"Tuesday", id: 1,isCheck:false,value:'Tu'};
  public wednesday:any =  {name :"Wednesday", id: 1,isCheck:false,value:'We'};
  public thursday:any =  {name :"Thursday", id: 1,isCheck:false,value:'Th'};
  public friday:any =  {name :"Friday", id: 1,isCheck:false,value:'Fr'};
  public saturday:any =  {name :"Saturday", id: 1,isCheck:false,value:'Sa'};
  public sunday:any =  {name :"Sunday", id: 1,isCheck:false,value:'Su'};
  public selectAllEmail:boolean = false;

  currRoute: string;

  options = {
    theme: 'light', // two possible values: light, dark
    dir: 'ltr', // two possible values: ltr, rtl
    layout: 'vertical', // fixed value. shouldn't be changed.
    sidebartype: "full", // four possible values: full, iconbar, overlay, mini-sidebar
    sidebarpos: 'fixed', // two possible values: fixed, absolute
    headerpos: 'fixed', // two possible values: fixed, absolute
    boxed: 'full', // two possible values: full, boxed
    navbarbg: 'skin6', // six possible values: skin(1/2/3/4/5/6)
    sidebarbg: 'skin5', // six possible values: skin(1/2/3/4/5/6)
    logobg: 'skin6' // six possible values: skin(1/2/3/4/5/6)
  };

  private _defaultSettings:UserSettings = {
        Application:"Application", 
        Layouts:"Layouts",
        SubLayouts:[
            {Id:2,Description:"Fixed Sidebar",IsChecked:"checked"}
        ],
        SelectedSubLayouts:"FixedHeader",
        SideBarTypes:"Sidebar Types",
        SubSideBarTypes:[
            // {Code:"mini-sidebar",Description:"Mini Sidebar"},
            // {Code:"iconbar",Description:"Icon Sidebar"},
            // {Code:"overlay",Description:"Overlay Sidebar"},
            {Code:"full",Description:"Full Sidebar"}
        ],
        GeneralSettings: "General Settings",
        SubSideBarSelected:"full",
        WebResSettingsDescription:"WebResolution Settings",
        WebResSettings:[{Code:"display1",Description:"Display 1"},{Code:"display2",Description:"Display 2"}],
        WebResSettingSelected:"display2",
        WebResCurrencySelected: {Code:"USD",Id:null},
        WebResClientSelected: "",
        WebResPeriodSelected: "",
        InvoiceGridHideSelectedColumn: {
          InvoiceNo:false,
          InvoiceDate:false, 
          NoOfShipment:false,
          DueDate:false,
          ClientCode:false,
          ClientRegion:false,
          ClientCountry:false,
          ClientCity:true,
          ClientDivision:true,
          ClientLocation:true,
          CarrierCode:false,
          CarrierName:false,
          CarrierCity:false,
          CarrierCountry:false,
          Currency:false,
          BilledAmount:false,
          ShipmentMode:false,
          ServiceLevel:false,
          OriginCountryCode:false,
          DestinationCountryCode:false,
          ResolutionReasonCode:false
        },
        RuleDisplayColumnSummary:[]
    }; 

  clientDropdownDisable: boolean = false;

  blackListRoute: Array<string> = [
    '/ctms/orders/order-details',
    '/ctms/shipments/shipment-details'
  ];

  applicationUrl: SafeUrl;

  constructor(
    private _authService: AuthService,  
    private _userService: UserService,
    private _cookieService: CookieService, 
    private _customCookieService: CustomCookieService,
    private _env: EnvService,
    private _sharedService: ShareService,  
    private _multiRaterService: MultiRaterService,
    private _router: Router,
    private fb: UntypedFormBuilder,
    private router: Router,
    private elem: ElementRef,
    private activatedRoute: ActivatedRoute,
    private _notificationService: NotificationService,
    private _appService: AppService,
    private globalS: GlobalService,
    private santizer: DomSanitizer) { 

    this.applicatePage = this._env.rateTrakApplicationPage;

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((navs: NavigationEnd) => {

        this.currRoute = this.createBreadCrumb(this.activatedRoute.root);
        
        if(this.blackListRoute.some(x => navs.url.includes(x))){
          this.clientDropdownDisable = true;
        } else {
          this.clientDropdownDisable = false;
        }
      });

      this.applicationUrl = this.santizer.bypassSecurityTrustResourceUrl(this._env.rateTrakApplicationPage);
      
   }

  ngOnInit() {
      this.GET_ENVIRONMENT_VARIABLE();
      this.buildForm();

      this._appService.GetInvoiceStatus().subscribe(invStatus => {
          this.invoiceStatus = invStatus;
      });

      this._authService.getUserIdentity().then(user => {
        
        if(!!user){
          this._appService.getCurrency().pipe(
            switchMap(currency => {          
              this.currencyDropDownList = currency.map(x => {
                return {
                  Id: x.Id,
                  Code: x.Code
                }
              });
              return this._userService.getProfile()
            }),
            switchMap(response => {
              this._userProfile = response;              
              return this._appService.getClients()
            })
          ).subscribe(data => {              
              this.roleClients = data;

              this.globalS.CLIENT_CURRENCY_LIST = {
                currency: this.currencyDropDownList,
                client: data
              };

              this.GET_USERSETTINGS({
                currency: this.currencyDropDownList,
                client: data
              });

              if((data.Role == "Client" || data.Role == "Carrier") && data.Clients.length > 1 ){
                this.navForm.patchValue({
                  client: data.Clients[0],
                  currency: this.navForm.get('currency').value,
                });
              }else if(data.Clients.length == 1){
                this.navForm.patchValue({
                  client: data.Clients[0],
                  currency: this.navForm.get('currency').value,
                });
              }
              

              this.SAVE_DEFAULT_SETTINGS_NAVIGATION(this.navForm.get('client').value, this.navForm.get('currency').value);
              
              this._sharedService.clientCurrencyChange.next({
                currency: this.navForm.get('currency').value,
                client: this.navForm.get('client').value
              });
          });
        }
      });
  }

  GET_ENVIRONMENT_VARIABLE(){
    const host = window.location.hostname;

    if(host.includes('test')){
      this.environment = 'TEST';
      return;
    }

    if(host.includes('staging')){
      this.environment = 'STAGING'
      return;
    }
    this.environment = '';
  }

  createBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: Array<any> = []): any {

    const children: Array<ActivatedRoute> = route.children;

    if (children.length === 0) {
      return route.snapshot.data['title'];
    }

    for (var child of children) {
      const routeURL: string = child.snapshot.url.map(x => x.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }
      breadcrumbs.push({ label: routeURL, url: url })
      return this.createBreadCrumb(child, url, breadcrumbs);
    }
  }

  ngAfterViewInit(){
    this.optionsEvent.emit(this.options);
    this.load = true;
  }

  search(){
    this._sharedService.emitFilterChangeSource.next(this.filterForm.value);
  }

  buildForm(){
    this.filterForm = this.fb.group(defaultFilterValue);

    this.navForm = this.fb.group({
      client: null,
      currency: null,
      period: null
    });

    combineLatest([
      this.navForm.get('client').valueChanges.pipe(startWith('')),
      this.navForm.get('currency').valueChanges.pipe(startWith(''))
    ]).subscribe(data => {
        // Check if both subscriptions return a value
        if(data[0] && data[1]){
          this.SAVE_DEFAULT_SETTINGS_NAVIGATION(data[0], this.GET_CURRENCY_OBJECT(data[1]));      
          this._sharedService.clientCurrencyChange.next({
            currency: this.GET_CURRENCY_OBJECT(data[1]),
            client: this.navForm.get('client').value
          });
        }
    });

    this._sharedService.clientCurrencyEmit$.pipe().subscribe(data => {
      var filteredData = { currency: data?.currency?.Id, client: data?.client }
      this.navForm.patchValue( filteredData, { emitEvent: false });
    });
    
  }

  GET_CURRENCY_OBJECT(id: number): any{
    return this.currencyDropDownList?.filter(x => x.Id == id).shift();
  }
  
  selectionChangeClient(value: any){
    this.userSettings.WebResClientSelected = value;
    this.navForm.patchValue({ client: value })
    this.updateApplicationSettings();
  }

  selectionChangeHistory(value: any){
    this.userSettings.WebResPeriodSelected = value;
    this.navForm.patchValue({ period: value })
    this.updateApplicationSettings();
  }

  // UserApplicationSettings
  GET_USERSETTINGS(d_CLIENTS_CURRENCY: any = null){
    
    this._userService.getApplicationSettings()
        .pipe(
          switchMap(response => {
            if(response == null || response.UserSettings == null || response.UserSettings == ''){
              return this._userService.AddApplicationSettings(this._defaultSettings);
            }
            return of(response);
          })
        ).subscribe(response =>
      {
        this.userSettings = this.globalS.defaultApplicationSettings(JSON.parse(response.UserSettings), d_CLIENTS_CURRENCY);

        this.navForm.patchValue({
          client:     this.userSettings.WebResClientSelected,
          currency:   this.userSettings.WebResCurrencySelected?.Id,
          period:     this.userSettings.WebResPeriodSelected
        });

        this.selectedItemCurrency = this.userSettings.WebResCurrencySelected;

        this.SAVE_DEFAULT_SETTINGS_NAVIGATION(this.navForm.get('client').value, this.userSettings.WebResCurrencySelected);

        this.settings.emit(JSON.stringify(this.userSettings));
        this.initThemes();
      });
  }

  SAVE_DEFAULT_SETTINGS_NAVIGATION(client: string, currency: any){

    this.UPDATE_CLIENT(client);
    this.UPDATE_CURRENCY(currency);

    this.updateApplicationSettings();
    
    this._cookieService.put("__defaultSettings", JSON.stringify({
      client: client,
      currency:  currency
    }));
  }

  UPDATE_CLIENT(client: string){
    if(this.userSettings && 'WebResClientSelected' in this.userSettings){
      this.userSettings['WebResClientSelected'] = client;
    }
  }

  UPDATE_CURRENCY(currency: any){
    if (this.userSettings && 'WebResCurrencySelected' in this.userSettings) {
      this.userSettings["WebResCurrencySelected"] = currency
    }
  }

  private initCurrency() {
    var scope = this;

    scope.currencyDropDownList.map(function(a) {
      if(a.Code === 'USD' || a.Code === 'EUR' || 
          a.Code === 'GBP' || a.Code === 'CAD' ||
          a.Code === 'AUD' || a.Code === 'JPY' || 
          a.Code === 'CNY' || a.Category === 'Common')
          {
            a.Category = 'Common';
          }
          else{
            a.Category = 'All';
          }
          return a;
      }
    );
  }

  initThemes(){
    this.webResEmitValue.Type = "Grid"
    this.webResEmitValue.Value = this.userSettings.WebResSettingSelected;
    let isNavHeaderLoaded = this._cookieService.get("__isNavHeaderLoaded");

    if(isNavHeaderLoaded == ''  || isNavHeaderLoaded === undefined){
       this._sharedService.emitChange(this.webResEmitValue);
    }

    this.webResEmitValue.Type = "DropDownCurency"
    this.webResEmitValue.Value = this.userSettings.WebResCurrencySelected;
    if(isNavHeaderLoaded == '' || isNavHeaderLoaded === undefined){
      this._sharedService.emitChange(this.webResEmitValue);
      this._cookieService.put("__isNavHeaderLoaded","TRUE")
   }

    this.userSettings.SubLayouts.forEach(item=>{
      if(item.IsChecked === 'checked') {
        this.options.sidebarpos = 'fixed';
      }else{
        this.options.sidebarpos = 'absolute';
      }
    })
    this.optionsEvent.emit(this.options);
  }

  initSidebar(sidebarType){
    this.options.sidebartype = sidebarType;
    this.optionsEvent.emit(this.options);
  }

  //currency dropdown properties
  public selectionChangeCurrency(value) {

    this.userSettings.WebResCurrencySelected = value;

    this._sharedService.clientCurrencyChange.next({
      currency: this.GET_CURRENCY_OBJECT(value.Id),
      client: this.navForm.get('client').value
    });

    this.updateApplicationSettings();
  }

  public handleFilter(value) {
    if(value === null || value === "" ){
      this.initCurrency();
    }
    else {
      this.groupCurrency = this.currencyDropDownList.filter((s) => s.Code.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } 
  }

  showProcess(event: any, type: string){
    event.stopPropagation();
    if(type == 'layout'){
      this.showLayouts = !this.showLayouts;
      this.showSideBar = false
    }
    if(type == 'sidebar'){
      this.showSideBar = !this.showSideBar;
      this.showLayouts = false;
    }
    if(type == 'webresolution'){
      this.showWebRes = !this.showWebRes;
    }
    if(type == 'general'){
      this.showGeneralSettings = !this.showGeneralSettings;
    }
    this.optionsEvent.emit(this.options);
  }

  reset(): void{
    this.showLayouts = false;
    this.showSideBar = false;

    this.showWebRes = false;
    this.showGeneralSettings = false;
  }

  openChange(isChange: boolean): void{
    if(isChange) {
      this.reset();
    };
  }

  redirectToApplication(){
    // window.location.href = this._env.rateTrakApplicationPage;
    // this.applicationUrl = this.santizer.bypassSecurityTrustResourceUrl(this._env.rateTrakApplicationPage);
  }

  changeEvent(event, type: number){
    if(type == 1){
      this.options.theme = event ? 'dark' : 'light'
    }
    if(type == 2){
      this.options.sidebarpos = event ? 'fixed' : 'absolute'
    }
    if(type == 3){
      this.options.headerpos = event ? 'fixed' : 'absolute'
    }
    if(type == 4){
      this.options.boxed = event ? 'boxed' : 'full'
    }
    if(type == 5){
      this.options.dir = event ? 'rtl' : 'ltr'
    }
    this.userSettings.SubLayouts.forEach( (item) => 
    {
      if(item.Id == type)
        item.IsChecked = (item.IsChecked === 'checked')?null:'checked'
    });
    this.optionsEvent.emit(this.options);
    this.updateApplicationSettings();
  }

  webResInvoiceGrid(data,code){
    this.webResEmitValue.Type = "Grid"
    this.webResEmitValue.Value = data;
    this._sharedService.emitChange(this.webResEmitValue);
    this.userSettings.WebResSettingSelected = code;
    this.updateApplicationSettings();
  }

  changeSideBar(sidebarType){
    this.options.sidebartype = sidebarType;
    this.optionsEvent.emit(this.options);
    this.userSettings.SubSideBarSelected = sidebarType;
    this.updateApplicationSettings();
  }
  
  onClick(event: Event) {
    if (this.listDrop && !this.listDrop.nativeElement.contains(event.target)){
      this.logout.close();
    }
  }

  private updateApplicationSettings(): void
  {
    // if usersettings object is undefined and unchecked by angular event loop just dont send and update API
    if(this.globalS.isEmpty(this.userSettings)) return;
    this._userService.UpdateApplicationSettings(this.userSettings).subscribe((data:any) => {});
    this._cookieService.put("__userSettings", JSON.stringify(this.userSettings));
  }

  changeWebResSetting(webResSettings){
    this.userSettings.WebResSettingSelected = webResSettings;
  }

  emailAlert(){
    this.isEmailAlert = true;
    var scope = this;
    this._userService.GetEmailAlert().subscribe(response =>
      {
        response.forEach(element => {
          if(element.Value == 'Mo'){
            this.monday.isCheck = true;
          }
          if(element.Value == 'Tu'){
            this.tuesday.isCheck = true;
          }
          if(element.Value == 'We'){
            this.wednesday.isCheck = true;
          }
          if(element.Value == 'Th'){
            this.thursday.isCheck = true;
          }
          if(element.Value == 'Fr'){
            this.friday.isCheck = true;
          }
          if(element.Value == 'Sa'){
            this.saturday.isCheck = true;
          }
          if(element.Value == 'Su'){
            this.sunday.isCheck = true;
          }
        });
        scope.isSelectAll();
      })
  }

  selectAll(){ 
    if(this.selectAllEmail){
      this.monday.isCheck = true;
      this.tuesday.isCheck = true;
      this.wednesday.isCheck = true;
      this.thursday.isCheck = true;
      this.friday.isCheck = true;
      this.saturday.isCheck = true;
      this.sunday.isCheck = true;
    }else{
      this.monday.isCheck = false;
      this.tuesday.isCheck = false;
      this.wednesday.isCheck = false;
      this.thursday.isCheck = false;
      this.friday.isCheck = false;
      this.saturday.isCheck = false;
      this.sunday.isCheck = false;
    }
  }

  isSelectAll(){
    if(this.monday.isCheck && 
      this.tuesday.isCheck && 
      this.wednesday.isCheck && 
      this.thursday.isCheck && 
      this.friday.isCheck && 
      this.saturday.isCheck && 
      this.sunday.isCheck ){
        this.selectAllEmail = true;
    }else{
      this.selectAllEmail = false;
    }
  }
  onChange(data: any){
    this.isSelectAll();
  }

  closeEmailAlert(){
    this.isEmailAlert = false;
  }

  saveEmailAlert(){
   
    var emailAlertList = [];
    if(this.monday.isCheck)
      emailAlertList.push("Mo");
    
    if(this.tuesday.isCheck)
      emailAlertList.push("Tu");

    if(this.wednesday.isCheck)
      emailAlertList.push("We");

    if(this.thursday.isCheck)
      emailAlertList.push("Th");

    if(this.friday.isCheck)
      emailAlertList.push("Fr");

    if(this.saturday.isCheck)
      emailAlertList.push("Sa");

    if(this.sunday.isCheck)
      emailAlertList.push("Su");
      
    this._userService.AddEmailAlert(emailAlertList).subscribe(response =>{
      this._notificationService.show({
        content: 'Successfully saved!',
        animation: { type: 'fade', 
        duration: 500 },
        type: { style: 'success', icon: true }
       });
    });
  }

  public isUserGuide:boolean = false;
  public userGuideList:any;
  userGuide(){
   
    this._userService.GetUserGuide().subscribe(response =>{
      this.isUserGuide = true;
      this.userGuideList = response;
    })
  }

  closeUserGuide(){
    this.isUserGuide = false;
  }

  public openDownload(guide){
    this._userService.GetUserGuideAttachment(guide.Id).subscribe((blobObj) =>{
      var ext =  guide.Filename.split('.').pop();
      if(ext == "pdf"){
        var url = window.URL.createObjectURL(blobObj);
        window.open(url);
      }else{ 
        importedSaveAs(blobObj, guide.Filename);
      }
    },
    (err) => {
      console.log("error: " + err.error);
    });
  }

  logoff() {
    this.updateApplicationSettings();
    this._customCookieService.removeAllCookiesExceptOidc();
    this._authService.logout();
  }
}
